export var easeInOut = 'cubic-bezier(0.15,1,0.3,1)';
export var easeOut = 'cubic-bezier(0.2,0,0,1)';
export var easeIn = 'cubic-bezier(0.8,0,0,0.8)';
//# sourceMappingURL=curves.js.map